import React from 'react';
import PropTypes from 'prop-types';

const ButtonPlaceholder = ({ className }) => (
  <div
    className={`placeholder-row placeholder-st__bottom-signin animation ${className}`}
  />
);

ButtonPlaceholder.propTypes = {
  className: PropTypes.string
};

export default ButtonPlaceholder;
